import { SBaseDisplay } from '@summit/core';

import { EboObjectTO } from '../../base-classes/ebo-object-to';
import { Incentive } from '../../payroll/incentive/incentive';
import { EmployeeWage } from './employee-wage';

export class EmployeeWageIncentive extends EboObjectTO implements SBaseDisplay {
  employeeWageID: string;
  employeeWage: EmployeeWage;
  incentiveID: string;
  incentive: Incentive;

  constructor(jsonData?: Partial<EmployeeWageIncentive>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.employeeWage) this.employeeWage = new EmployeeWage(jsonData.employeeWage);
      if (jsonData.incentive) this.incentive = new Incentive(jsonData.incentive);
    }
  }

  toShortString(): string {
    return this.incentive?.name;
  }
}
